import { environment } from "../../environment";
import { getApiEndpoint } from "../../utils/constants/api";
import { PAGE_TEMPLATES } from "../../utils/constants/templates";
import { wfetch } from "../../utils/fetch";

export const FETCH_BRAND = "FETCH_BRAND";

export const fetchBrand = () => {
    return async (dispatch, getState) => {
        const brandId = getState().rootPageData?.brand;

        // Dispatch an empty brand instead of returning early: on a site switch the previous
        // site's brand must be cleared when the new root page defines none or the lookup
        // fails.
        if (!brandId) {
            dispatch({ type: FETCH_BRAND, payload: {} });
            return;
        }

        const response = await wfetch(
            getApiEndpoint("BRANDS", {
                queryParams: {
                    "@jcr:uuid": brandId,
                },
            }),
        );

        dispatch({
            type: FETCH_BRAND,
            payload: response && response.data.results.length > 0 ? response.data.results[0] : {},
        });
    };
};
